import {useEffect, useRef} from "react";
import { CSSTransition } from "react-transition-group";
import { useHudOverlay } from "widgets/hud/model/overlayStore.ts";
import { useUserStore } from "entities/user";
import {AnimatedWrap, Title, Subtitle, ProfileModalHeaderWrap} from "./styles.ts";
import { useOutClick } from "../../../app/lib/hooks/useOutClick.ts";
import {mergeRefs} from "shared/helpers";
import {ProfileDrawer} from "widgets/profile/ui/ProfileSection/ProfileDrawer.tsx";
import Button from "@atomaro/ui-kit/components/Button/Button/Button";
import {SignOutIcon} from "shared/ui/icons";
import {PasswordEditorDrawer} from "widgets/profile/ui/PasswordSection/PasswordEditorDrawer.tsx";
import {useResize} from "../../../app/lib/hooks/useResize.ts";
import {EditProfileNav} from "widgets/profile/ui/ui/EditProfileNav.tsx";
import {PasswordEditor} from "widgets/profile/ui/PasswordSection/PasswordEditor.tsx";
import userImg from 'shared/assets/img/user.png'
import {useModals} from "widgets/profile/lib/modalsStore.ts";


export const ProfileModal = () => {
    const openId = useHudOverlay((s) => s.openId);
    const close = useHudOverlay((s) => s.close);
    const toggle = useHudOverlay((s) => s.toggle);
    const userInfo = useUserStore((s) => s.userInfo);
    const activeSection = useModals((s) => s.openId)
    const setActiveSection = useModals((s) => s.change)
    const { isScreenMd } = useResize();
    
    const containerRef = useRef<HTMLDivElement | null>(null);
    const nodeRef = useRef<HTMLDivElement | null>(null);
    
    const avatarId = userInfo?.profile?.avatar?.id
    const imgSrc = avatarId ? `/ecpp/attachments/files?attachmentId=${avatarId}` : userImg
    const imgAlt = avatarId ? `attachment_${avatarId}` : 'Profile icon'
    
    useOutClick(containerRef, close);

    const isOpen = openId?.includes("profile");
    
    useEffect(() => {
        if (!isOpen) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                // close();
            }
        };
        document.addEventListener("keydown", onKey);
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = prev;
        };
    }, [isOpen, close]);

    if (isScreenMd) return (
      <>
          <CSSTransition
            in={isOpen}
            timeout={{ enter: 200, exit: 150 }}
            classNames="hud-slide"
            unmountOnExit
            nodeRef={nodeRef}
          >
              <AnimatedWrap
                ref={mergeRefs(containerRef, nodeRef)}
                role="dialog"
                aria-modal="true"
              >
                  <ProfileModalHeaderWrap>
                      <img src={imgSrc} alt={imgAlt} height={72} width={72} />
                      <Title>{userInfo?.name.first} {userInfo?.name.last}</Title>
                      <Subtitle>{userInfo?.credentials.email}</Subtitle>
                  </ProfileModalHeaderWrap>
                  
                  <EditProfileNav
                    activeSection={activeSection}
                    setActiveSection={setActiveSection}
                  />
                  
                  <Button
                    label={"Выйти из аккаунта"}
                    style={{background: "transparent", marginTop: "8px"}}
                    variant={"secondary"}
                    size={"m"}
                    iconPrefix={<SignOutIcon />}
                    onClick={() => toggle('logout')}
                  />
              </AnimatedWrap>
          
          </CSSTransition>
          <ProfileDrawer
            onClose={() => setActiveSection(null)}
            onSubmit={() => {}}
            isOpen={activeSection === 'profileInfo'}
          />
          <PasswordEditorDrawer
            isOpen={activeSection === 'profilePass'}
            onClose={() => setActiveSection(null)}
          >
              <PasswordEditor
                onSubmit={() => {}}
                onClose={() => setActiveSection(null)}
              />
          </PasswordEditorDrawer>
      </>
    );
};

export default ProfileModal;
